import { AulaState } from '@core/types/state';

const changeConversationName = (
  state: AulaState['inboxv2'],
  action: { type: string; payload: string }
): AulaState['inboxv2'] => ({
  ...state,
  createConversationName: action.payload,
});

export default changeConversationName;
